/**
 * Pre-QC carton serial window: the first scan on a carton is the anchor.
 * Later numeric serials must stay within +/- this range unless the operator confirms a new anchor.
 */

export const CLAMP_QC_SERIAL_ANCHOR_RANGE = 30;

export function parseClampQcSerialAnchorNumber(trimmedSerial: string): number | null {
  const digits = trimmedSerial.trim();
  if (!/^\d+$/.test(digits)) {
    return null;
  }
  const parsed = Number.parseInt(digits, 10);
  if (!Number.isSafeInteger(parsed) || String(parsed) !== digits) {
    return null;
  }
  return parsed;
}

export function clampQcSerialIsOutsideAnchorRange(
  anchor: number,
  serialNumber: number,
  range: number = CLAMP_QC_SERIAL_ANCHOR_RANGE,
): boolean {
  return Math.abs(serialNumber - anchor) > range;
}
